'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Category = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Category, _Component);

  function Category() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Category);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Category.__proto__ || (0, _getPrototypeOf2.default)(Category)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Category, [{
    key: 'render',
    value: function render() {
      var styles = require('./Category.scss');
      return _react2.default.createElement(
        _reactBootstrap.Grid,
        { className: styles.category },
        _react2.default.createElement(
          _reactBootstrap.Row,
          null,
          _react2.default.createElement(
            _reactBootstrap.Col,
            { md: 12 },
            _react2.default.createElement(
              'div',
              { className: styles.groupCat },
              _react2.default.createElement(
                'div',
                { className: styles.itemsCat + ' ' + styles.itemSalonMiMong },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/salon-mi-va-mong' },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Salon Mi v\xE0 M\xF3ng'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.itemsCat + ' ' + styles.itemSpaChamDa },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/spa-cham-da' },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Spa Ch\u0103m Da'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.itemsCat + ' ' + styles.itemMassageGoiDau },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/massage-va-goi-dau' },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Massage G\u1ED9i \u0110\u1EA7u'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.itemsCat + ' ' + styles.itemThamMyNhaKhoa },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/tham-my-va-nha-khoa' },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Th\u1EA9m M\u1EF9 Nha Khoa'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                {
                  className: styles.itemsCat + ' ' + styles.itemSalonTocMakeUp
                },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/salon-toc-va-make-up' },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Salon T\xF3c Make-up'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Category;
}(_react.Component), _class.propTypes = {}, _temp2);
exports.default = Category;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Partials/Category.js
// module id = 1645
// module chunks = 0